module.exports = __webpack_public_path__ + "f51b337e81a28b331543f8f04c7df6aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/sbtool/images/sbtool-logo-smaller.png
// module id = 1310
// module chunks = 1